import loadable from '@loadable/component'

export default loadable(() => import(/* webpackChunkName: "Bookkeeping" */'pages/Bookkeeping/Bookkeeping'))